<template>
  <section>
    <v-list>
      <v-list-group
        v-for="(theme, themeIndex) in themes"
        :key="`theme-${themeIndex}`"
        no-action
        :append-icon="getThemeAppendIcon(theme)"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-subtitle @click="onThemeClick(theme)">
              {{ theme.EventTranslationName }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <template v-if="hasMultiChildren(theme)">
          <v-list-item
            v-for="(child, childIndex) in theme.Children"
            :key="`child-${childIndex}`"
            class="pl-10"
            @click="onEventClick(child)"
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ child.EventTranslationName }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-group>
    </v-list>
  </section>
</template>

<script>
export default {
  name: 'HeaderThemesMobile',
  computed: {
    themes() {
      return this.$store.getters['Account/themes'];
    },
  },
  methods: {
    hasChildrenData(theme) {
      return theme != null && theme.Children != null;
    },
    hasMultiChildren(theme) {
      return this.hasChildrenData(theme) && theme.Children.length > 1;
    },
    onThemeClick(theme) {
      // Go to the first child upon theme click
      if (theme.Children.length === 0) {
        this.onEventClick(theme);
      } else {
        const [event] = theme.Children;
        this.onEventClick(event);
      }
    },
    onEventClick(event) {
      this.$emit('close-menu');
      this.$router.push({
        name: 'EventDetails',
        params: { event_id: event.EventId },
      });
    },
    getThemeAppendIcon(theme) {
      if (this.hasMultiChildren(theme)) {
        return 'keyboard_arrow_down';
      }
      return '';
    },
  },
};
</script>
